import useDataStore from '#/common/hooks/useDataStore';
import { BaseDataStoreOptions } from '#/common/hooks/useDataStore/DataStoreOptions';
import { getManufacturerList, getManufacturer } from '#/graphql/queries';
import { Manufacturer } from '#/graphql/types';
import { gql } from '@apollo/react-hooks';

const getManList = gql(getManufacturerList);
const getMan = gql(getManufacturer);

const useManufacturerDataStore = (options: BaseDataStoreOptions<Manufacturer> = {}) => {
  return useDataStore({
    ...options,
    getItemList: getManList,
    getItem: getMan,
  });
};

export default useManufacturerDataStore;
